import { DetailsDeviceState } from './states/details-device.state';
import { DetailsDeviceDataloggerState } from './states/details-device-datalogger.state';

export const detailsDeviceState = [DetailsDeviceState, DetailsDeviceDataloggerState];
